export default __webpack_public_path__ + "static/media/Starry_iMac.0b33fe43.mp4";